import SearchIcon from "@mui/icons-material/Search";
import { IconButton, Tooltip } from "@mui/material";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import {
  selectIsAdvancedSearchOpen,
  setIsAdvancedSearchOpen,
} from "../../app/slices/GlobalSlice";
import "./SearchTriggerPill.css";

export default function SearchTriggerPill() {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectIsAdvancedSearchOpen);

  return (
    <Tooltip title="Search (/)">
      <IconButton
        size="small"
        aria-label="Open advanced search"
        className={classNames("search-trigger-pill", {
          "search-trigger-pill--active": isOpen,
        })}
        onClick={() => dispatch(setIsAdvancedSearchOpen(true))}
      >
        <SearchIcon fontSize="inherit" />
      </IconButton>
    </Tooltip>
  );
}
